import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentHomePerson: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <Path
      d='M10.55 2.532a2.25 2.25 0 012.9 0l6.75 5.692c.507.428.8 1.057.8 1.72v2.82a2.99 2.99 0 00-1.5-.723V9.944a.75.75 0 00-.267-.573l-6.75-5.692a.75.75 0 00-.966 0L4.767 9.37a.75.75 0 00-.267.573v9.803c0 .138.112.25.25.25h3.5a.25.25 0 00.25-.25v-5.5c0-.966.784-1.75 1.75-1.75h3.5c.966 0 1.75.784 1.75 1.75v2.881A2.251 2.251 0 0014 19.25v-5.003a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25v5.5a1.75 1.75 0 01-1.75 1.75h-3.5A1.75 1.75 0 013 19.747V9.944c0-.663.293-1.292.8-1.72l6.75-5.692zM19 13a2 2 0 100 4 2 2 0 000-4zm-4 6.25c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v.088c.001.071.002.142-.001.213a2.734 2.734 0 01-.066.453 2.99 2.99 0 01-.46 1.033c-.547.78-1.587 1.463-3.473 1.463s-2.926-.683-3.472-1.463a2.99 2.99 0 01-.519-1.38 2.033 2.033 0 01-.008-.106L15 19.253v-.003z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentHomePerson
